const emailPreviewExtensions = ['.msg'];

const emailPreviewMimeTypes = ['application/octet-stream', 'application/vnd.ms-outlook'];

const outlookExtensions = [...emailPreviewExtensions, '.eml', '.emlx'];

const outlookMimeTypes = ['application/vnd.ms-outlook', 'message/rfc822'];

const audioVideoExtensions = ['.mp3', '.aac', '.mp4', '.mpeg', '.avi', '.flv', '.wmv', '.mov', '.aiff', '.flac', '.m4a', '.ogg', '.wav', '.wma'];

const officeFileExtensions = [
  '.csv',
  '.pdf',
  '.epub',
  '.fb2',
  '.xlsx',
  '.xls',
  '.docx',
  '.doc',
  '.pptx',
  '.ppt',
  '.tar',
  '.gz',
  '.bz2',
  '.zip',
  '.rar',
];

const pictureFilesExtensions = ['.gif', '.png', '.jpg', '.jpeg', '.bmp', '.svg'];

const allowedExtensions = [...outlookExtensions, ...audioVideoExtensions, ...officeFileExtensions, ...pictureFilesExtensions];

const audioVideoMimeTypes = ['audio/mpeg', 'audio/aac', 'video/mp4', 'video/mpeg', 'audio/ogg', 'video/ogg'];

const uploadAccepts = [
  'image/*',
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
  'application/msword',
  'application/vnd.ms-powerpoint',
  'text/plain',
  ...outlookMimeTypes,
  ...audioVideoMimeTypes,

  ...allowedExtensions,
];
//the same in FileHelper.cs
const disallowedFileExtensions = [
  '.ade',
  '.adp',
  '.app',
  '.bas',
  '.bat',
  '.chm',
  '.class',
  '.cmd',
  '.com',
  '.cpl',
  '.crt',
  '.dll',
  '.exe',
  '.fxp',
  '.hlp',
  '.hta',
  '.ins',
  '.isp',
  '.jse',
  '.lnk',
  '.mda',
  '.mdb',
  '.mde',
  '.mdt',
  '.mdw',
  '.mdz',
  '.msc',
  '.msi',
  '.msp',
  '.mst',
  '.ops',
  '.pcd',
  '.pif',
  '.prf',
  '.prg',
  '.reg',
  '.scf',
  '.scr',
  '.sct',
  '.shb',
  '.shs',
  '.svg',
  '.url',
  '.vb',
  '.vbe',
  '.vbs',
  '.wsc',
  '.wsf',
  '.wsh',
  '.application',
  '.gadget',
  '.jar',
  '.js',
  '.ws',
  '.ps1',
  '.ps1xml',
  '.ps2',
  '.ps2xml',
  '.psc1',
  '.psc2',
  '.msh',
  '.msh1',
  '.msh2',
  '.mshxml',
  '.msh1xml',
  '.msh2xml',
  '.inf',
  '.html',
  '.htm',
  '.asp',
  '.aspx',
  '.cs',
  '.config',
  '.ascx',
];

const unsupportedFileTypeDefaultMsg = `Unsupported file type or file extension chosen. 
  Supported files: ${uploadAccepts.join(', ')}`;
  
const isValidFileBeforeUpload = (name, type) => {
  let extenssion = getFileExtension(name);
  if (!extenssion) {
    return false;
  } else {
    if (disallowedFileExtensions.includes(extenssion)) {
      return false;
    }

    if (
      !disallowedFileExtensions.includes(extenssion) &&
      (uploadAccepts.includes(type) || uploadAccepts.includes(extenssion) || type.startsWith('image/'))
    ) {
      return true;
    }

    // todo need more deep validation for file types
    // if(!type)
    // {
    //   return false;
    // }
    return false;
  }
};

const getFileExtension = (fileName) => {
  const arr = fileName?.split('.');
  const ext = arr?.length >= 2 ? arr.pop()?.toLowerCase() : null;

  if (ext) {
    return '.' + ext;
  } else {
    return '';
  }
};

const getFileNameWithoutExtension = (fullFileName) => {
  const lastPointIndex = fullFileName?.lastIndexOf('.');
  if (lastPointIndex > 0) {
    return fullFileName?.substring(0, lastPointIndex);
  } else {
    return fullFileName;
  }
};

export {
  uploadAccepts,
  disallowedFileExtensions,
  getFileExtension,
  getFileNameWithoutExtension,
  allowedExtensions,
  isValidFileBeforeUpload,
  unsupportedFileTypeDefaultMsg,
  emailPreviewExtensions,
  emailPreviewMimeTypes,
};
